<template>
  <div id="profileView">
    <AppBar />

    <div class="area">
      <div class="area-head">
        <div>
          <h1 class="greet" style="font-size:var(--font-size-3xl)">
            Minha conta
          </h1>
          <p class="sub">Seus dados, preferências e segurança.</p>
        </div>
      </div>

      <div class="acct-grid">
        <!-- SIDE NAV -->
        <nav class="card acct-nav">
          <a
            href="#dados"
            :class="{ on: activeNav === 'dados' }"
            @click="activeNav = 'dados'"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <circle
                cx="12"
                cy="8"
                r="4"
                stroke="currentColor"
                stroke-width="2"
              />
              <path
                d="M4 21c0-4 4-6 8-6s8 2 8 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            Dados pessoais
          </a>
          <a
            href="#notif"
            :class="{ on: activeNav === 'notif' }"
            @click="activeNav = 'notif'"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M10.3 21a1.94 1.94 0 0 0 3.4 0"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            Notificações
          </a>
          <a
            href="#pgto"
            :class="{ on: activeNav === 'pgto' }"
            @click="activeNav = 'pgto'"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <rect
                x="2"
                y="5"
                width="20"
                height="14"
                rx="2"
                stroke="currentColor"
                stroke-width="2"
              />
              <path d="M2 10h20" stroke="currentColor" stroke-width="2" />
            </svg>
            Pagamento
          </a>
          <a
            href="#seg"
            :class="{ on: activeNav === 'seg' }"
            @click="activeNav = 'seg'"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <rect
                x="4"
                y="10"
                width="16"
                height="11"
                rx="2"
                stroke="currentColor"
                stroke-width="2"
              />
              <path
                d="M8 10V7a4 4 0 0 1 8 0v3"
                stroke="currentColor"
                stroke-width="2"
              />
            </svg>
            Segurança
          </a>
          <span class="sep" />
          <button style="color:var(--color-danger)" @click="handleLogout">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Sair da conta
          </button>
        </nav>

        <!-- CONTEÚDO -->
        <div class="acct-main">
          <!-- DADOS PESSOAIS -->
          <section class="card acct-sec" id="dados">
            <h2>Dados pessoais</h2>
            <p class="sub">
              Mantemos estes dados para emissão de receitas e atestados.
            </p>
            <div class="acct-id">
              <div
                class="avatar avatar--xl avatar--ring"
                :style="
                  currentUser.photo
                    ? `background-image:url(${currentUser.photo});background-size:cover;background-position:center;`
                    : ''
                "
              >
                <span v-if="!currentUser.photo">{{ userInitials }}</span>
              </div>
              <div class="stack" style="gap:var(--space-2)">
                <span
                  style="font-size:var(--font-size-lg);font-weight:var(--fw-bold);color:var(--color-gray-900)"
                >
                  {{ currentUser.name }}
                </span>
                <button
                  class="btn btn--outline btn--sm"
                  style="align-self:flex-start"
                  @click="$bvModal.show('avatarModal')"
                >
                  Alterar foto
                </button>
              </div>
            </div>
            <div class="form-grid">
              <div class="field">
                <label class="label">Nome completo</label>
                <input class="input" v-model="form.name" />
              </div>
              <div class="field">
                <label class="label">CPF</label>
                <input
                  class="input num"
                  :value="formattedCpf"
                  readonly
                  style="background:var(--color-gray-50);color:var(--color-gray-500)"
                />
              </div>
              <div class="field">
                <label class="label">E-mail</label>
                <input class="input" type="email" v-model="form.email" />
              </div>
              <div class="field">
                <label class="label">Telefone</label>
                <input
                  class="input num"
                  type="tel"
                  v-model="form.phone_number"
                  v-mask="'(##) #####-####'"
                />
              </div>
              <div class="field">
                <label class="label">Data de nascimento</label>
                <input
                  class="input num"
                  v-model="form.birthday"
                  v-mask="'##/##/####'"
                  placeholder="DD/MM/AAAA"
                />
              </div>
              <div class="field">
                <label class="label">Gênero</label>
                <select class="select" v-model="form.gender">
                  <option value="">Selecione</option>
                  <option value="female">Feminino</option>
                  <option value="male">Masculino</option>
                  <option value="prefer_not_to_say">
                    Prefiro não informar
                  </option>
                </select>
              </div>
            </div>
            <div
              class="row"
              style="gap:var(--space-3);margin-top:var(--space-5)"
            >
              <button class="btn btn--primary" @click="saveUser">
                Salvar alterações
              </button>
              <button class="btn btn--ghost" @click="resetForm">
                Cancelar
              </button>
            </div>
          </section>

          <!-- NOTIFICAÇÕES -->
          <section class="card acct-sec" id="notif">
            <h2>Notificações</h2>
            <p class="sub">
              Escolha como quer ser avisada sobre suas consultas.
            </p>
            <div class="setting-row">
              <div class="tx">
                <b>Lembretes de consulta</b>
                <span>Aviso 24h e 1h antes de cada atendimento</span>
              </div>
              <label class="toggle">
                <input type="checkbox" v-model="notif.reminders" />
                <span class="track" />
              </label>
            </div>
            <div class="setting-row">
              <div class="tx">
                <b>E-mail</b>
                <span>Confirmações, recibos e documentos emitidos</span>
              </div>
              <label class="toggle">
                <input type="checkbox" v-model="notif.email" />
                <span class="track" />
              </label>
            </div>
            <div class="setting-row">
              <div class="tx">
                <b>SMS</b>
                <span>Lembretes por mensagem de texto</span>
              </div>
              <label class="toggle">
                <input type="checkbox" v-model="notif.sms" />
                <span class="track" />
              </label>
            </div>
            <div class="setting-row">
              <div class="tx">
                <b>Novidades e promoções</b>
                <span>Dicas de saúde e ofertas da Videomedi</span>
              </div>
              <label class="toggle">
                <input type="checkbox" v-model="notif.marketing" />
                <span class="track" />
              </label>
            </div>
          </section>

          <!-- PAGAMENTO -->
          <section class="card acct-sec" id="pgto">
            <h2>Formas de pagamento</h2>
            <p class="sub">Métodos salvos para agilizar o checkout.</p>
            <div class="doc-files">
              <CreditCardList ref="cardList" />
              <div class="docfile">
                <span class="ic ic--at">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M4 12l8-8 8 8-8 8z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <div class="info">
                  <b>PIX</b>
                  <span class="num">Pagamento instantâneo · sem cadastro</span>
                </div>
                <div class="acts">
                  <span class="badge badge--success badge--no-dot">
                    Disponível
                  </span>
                </div>
              </div>
            </div>
            <button
              class="btn btn--outline btn--sm"
              style="align-self:flex-start;margin-top:var(--space-4)"
              @click="$bvModal.show('createCreditCard')"
            >
              + Adicionar cartão
            </button>
          </section>

          <!-- SEGURANÇA -->
          <section class="card acct-sec" id="seg">
            <h2>Segurança</h2>
            <p class="sub">Proteja o acesso à sua conta.</p>
            <div class="setting-row">
              <div class="tx">
                <b>Senha</b>
                <span>Atualize para manter sua conta segura</span>
              </div>
              <button
                class="btn btn--outline btn--sm"
                @click="showPasswordForm = !showPasswordForm"
              >
                Alterar senha
              </button>
            </div>
            <PasswordForm v-if="showPasswordForm" />
            <div class="setting-row">
              <div class="tx">
                <b>Verificação em duas etapas</b>
                <span>Código por SMS ao entrar em um novo dispositivo</span>
              </div>
              <label class="toggle">
                <input type="checkbox" v-model="twoFactor" />
                <span class="track" />
              </label>
            </div>
            <div class="setting-row">
              <div class="tx">
                <b>Privacidade e LGPD</b>
                <span>Baixe ou exclua seus dados</span>
              </div>
              <button class="btn btn--ghost btn--sm" disabled>
                Gerenciar
              </button>
            </div>
            <div class="setting-row">
              <div class="tx">
                <b>Desativar conta</b>
                <span>Desative temporariamente o acesso à sua conta</span>
              </div>
              <button
                class="btn btn--danger btn--sm"
                @click="$bvModal.show('confirmationModal')"
              >
                Desativar
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>

    <footer class="foot-mini">
      <router-link to="/" class="vm-mark">
        <img
          class="vm-logo"
          src="../assets/images/logo-videomedi.png"
          alt="Videomedi"
        />
      </router-link>
      <span class="cpy">© 2026 Videomedi · CNPJ 00.000.000/0001-00</span>
      <div class="links">
        <a href="#">Privacidade</a>
        <a href="#">Termos de Uso</a>
        <a href="#">LGPD</a>
        <a href="#">Suporte</a>
      </div>
    </footer>

    <!-- Modal: alterar foto -->
    <BModal
      id="avatarModal"
      hide-footer
      centered
      title="Alterar foto de perfil"
    >
      <AvatarForm />
    </BModal>

    <!-- Modal: adicionar cartão -->
    <BModal
      id="createCreditCard"
      ref="createCreditCard"
      hide-footer
      centered
      title="Cadastrar um novo cartão"
    >
      <div v-if="!userHasAddress">
        <p class="sub" style="margin-bottom:var(--space-4)">
          Preencha o endereço antes de cadastrar o cartão.
        </p>
        <AddressForm @addressCreated="onAddressCreated" />
        <hr style="margin:var(--space-5) 0" />
      </div>
      <CreditCard @pushNewCreditCard="pushNewCreditCard" />
    </BModal>

    <!-- Modal: confirmar exclusão de conta -->
    <BModal
      id="confirmationModal"
      ref="confirmationModal"
      hide-footer
      hide-header
      centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-2">
          Ficamos tristes em saber que você vai nos deixar, não quer nos dar
          outra chance?
        </h4>
        <p class="title-2 text-color-secondary text-center mb-2">
          Se estiver mesmo decidido em desativar sua conta, basta clicar no
          botão Confirmar.
        </p>
        <p
          class="title-2 text-color-secondary text-center font-weight-bold mb-2"
        >
          Atenção: Seus dados ficarão preservados na plataforma. Quando você
          optar por voltar, basta logar novamente.
        </p>
        <p class="title-2 text-color-secondary text-center mb-4">
          Esperamos te ver em breve!
        </p>
        <BButton
          class="button2 mb-2"
          block
          style="background-color:var(--color-accent); color:#fff"
          @click="deleteAccount"
        >
          Confirmar
        </BButton>
        <BButton
          class="button2 mb-2"
          block
          @click="$bvModal.hide('confirmationModal')"
        >
          Cancelar
        </BButton>
      </div>
    </BModal>

    <!-- Modal: conta desativada -->
    <BModal
      id="accountDeleted"
      ref="accountDeleted"
      hide-footer
      hide-header
      centered
    >
      <div class="p-5">
        <h4 class="title-2 text-color-secondary text-center mb-4">
          Sua conta foi desativada
        </h4>
      </div>
    </BModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AppBar from "../components/AppBar.vue";
import CreditCard from "../components/CreditCard";
import CreditCardList from "../components/CreditCardList";
import PasswordForm from "../components/PasswordForm.vue";
import AddressForm from "../components/AddressForm.vue";
import AvatarForm from "../components/AvatarForm.vue";

export default {
  name: "Profile",
  components: {
    AppBar,
    CreditCard,
    CreditCardList,
    PasswordForm,
    AddressForm,
    AvatarForm
  },

  data() {
    return {
      activeNav: "dados",
      form: {
        name: "",
        email: "",
        phone_number: "",
        birthday: "",
        gender: ""
      },
      notif: {
        reminders: true,
        email: true,
        sms: true,
        marketing: false
      },
      twoFactor: false,
      showPasswordForm: false
    };
  },

  mounted() {
    document.body.className = "";
    document.body.classList.add("Base");
    this.resetForm();
  },

  methods: {
    ...mapActions("auth", ["logout", "clearLocalSession"]),

    toDisplayDate(iso) {
      if (!iso || iso.length !== 10) return iso || "";
      const [y, m, d] = iso.split("-");
      return y && m && d ? `${d}/${m}/${y}` : iso;
    },

    toIsoDate(br) {
      if (!br || br.length !== 10) return br || "";
      const [d, m, y] = br.split("/");
      return d && m && y ? `${y}-${m}-${d}` : br;
    },

    resetForm() {
      const u = this.currentUser || {};
      this.form = {
        name: u.name || "",
        email: u.email || "",
        phone_number: u.phone_number || "",
        birthday: this.toDisplayDate(u.birthday),
        gender: u.gender || ""
      };
    },

    saveUser() {
      this.$store.dispatch("user/updateUser", {
        id: this.currentUser.id,
        name: this.form.name,
        email: this.form.email,
        phone_number: this.form.phone_number,
        birthday: this.toIsoDate(this.form.birthday),
        gender: this.form.gender
      });
    },

    pushNewCreditCard(credit_card) {
      this.$refs.cardList && this.$refs.cardList.addCreditCard(credit_card);
    },

    onAddressCreated() {},

    handleLogout() {
      this.logout();
    },

    deleteAccount() {
      this.$store.dispatch("user/deleteUser").then(() => {
        this.$bvModal.show("accountDeleted");
        setTimeout(() => this.clearLocalSession(), 3500);
      });
    }
  },

  computed: {
    ...mapGetters("user", ["getCurrentUser"]),
    currentUser() {
      return this.getCurrentUser;
    },
    userInitials() {
      const name = (this.currentUser && this.currentUser.name) || "";
      return (
        name
          .split(" ")
          .slice(0, 2)
          .map(n => n[0])
          .join("")
          .toUpperCase() || "?"
      );
    },
    formattedCpf() {
      const raw =
        (this.currentUser &&
          (this.currentUser.cpf || this.currentUser.document_number)) ||
        "";
      if (!raw || raw === "—") return raw || "—";
      const digits = raw.replace(/\D/g, "");
      if (digits.length !== 11) return raw;
      return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    userHasAddress() {
      return !!(
        this.currentUser &&
        this.currentUser.address &&
        this.currentUser.address.id
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.vm-logo {
  display: block;
  height: 22px;
  width: auto;
}

#profileView {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--color-bg-page);
}
</style>
